import type { ReactNode } from 'react';
import { createContext, use } from 'react';

export function createStrictContext<T>(displayName: string) {
  const Context = createContext<T | undefined>(undefined);
  Context.displayName = displayName;

  const useStrictContext = (): T => {
    const context = use(Context);
    if (!context) throw new Error(`use${displayName} must be used within ${displayName}Provider.`);
    return context;
  };

  const Provider = ({ children, value }: { children: ReactNode; value: T }) => (
    <Context value={value}>{children}</Context>
  );

  return { useStrictContext, Provider } as const;
}
